import React from "react";
import { connect } from "react-redux";

import ReactTable from "react-table";
import Datetime from "react-datetime";
import SweetAlert from "react-bootstrap-sweetalert";
// react-select
import Select from "react-select";

import {
    getSolicitudesForTable, getSolicitudDetalle, resolverSolicitud, consultarGuia,
    limpiarDetalle, limpiarResolver, limpiarGuia, closeMessages
} from "../../../store/actions/autorizarActions";
import { logout } from "../../../store/actions/authActions";

import MapaComparativo from "./MapaComparativo.js";
import ImagenAuth from "components/ImagenAuth/ImagenAuth.js";

// core components
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import NavPills from "components/NavPills/NavPills.js";
import CustomInput from "components/CustomInput/CustomInput.js";
import Spinner from "components/Spinner/Spinner.js";

import InputLabel from "@material-ui/core/InputLabel";
import FormControl from "@material-ui/core/FormControl";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import CircularProgress from "@material-ui/core/CircularProgress";

import moment from 'moment';
import "moment/locale/es";

// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import VisibilityIcon from '@material-ui/icons/Visibility';
import RefreshIcon from '@material-ui/icons/Refresh';

import stylesSweetAlert from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styles from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";

const useStyles = makeStyles(styles);
const useStylesAlert = makeStyles(stylesSweetAlert);

var Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

// chip de estatus de la solicitud: naranja PENDIENTE / verde AUTORIZADA / rojo RECHAZADA
const chipColoresEstatus = {
    "PENDIENTE": { fondo: "#fff3e0", texto: "#e65100", borde: "#ffb74d" },
    "AUTORIZADA": { fondo: "#e8f5e9", texto: "#2e7d32", borde: "#81c784" },
    "RECHAZADA": { fondo: "#ffebee", texto: "#c62828", borde: "#e57373" },
};

// chip del estado de una entrega EAD (E/D/L)
const chipColoresEntrega = {
    "E": chipColoresEstatus["AUTORIZADA"],
    "D": chipColoresEstatus["RECHAZADA"],
    "L": { fondo: "#e3f2fd", texto: "#1565c0", borde: "#64b5f6" },
};

// chip discreto del tipo de solicitud: REVERSIÓN (revierte una entrega de hoy)
// vs DIRECTA (guía pendiente, sin entrega previa)
const chipColoresTipo = {
    "REVERSION": { fondo: "#eceff1", texto: "#455a64", borde: "#b0bec5" },
    "DIRECTA": { fondo: "#e3f2fd", texto: "#1565c0", borde: "#64b5f6" },
};

function chip(texto, colores) {
    const vColores = colores || { fondo: "#eeeeee", texto: "#616161", borde: "#bdbdbd" };
    return (
        <span style={{
            display: "inline-block",
            padding: "3px 10px",
            borderRadius: 12,
            fontSize: 11,
            fontWeight: 600,
            whiteSpace: "nowrap",
            backgroundColor: vColores.fondo,
            color: vColores.texto,
            border: "1px solid " + vColores.borde,
        }}>
            {texto}
        </span>
    );
}

const chipEstatus = (estatus) => chip(estatus, chipColoresEstatus[estatus]);
const chipEntrega = (estado, estadoTexto) => chip(estadoTexto || "—", chipColoresEntrega[estado]);
// tipo ausente (fila vieja o API sin el campo) se trata como REVERSION, el default de la columna
const chipTipo = (tipo) => chip(tipo === "DIRECTA" ? "DIRECTA" : "REVERSIÓN", chipColoresTipo[tipo] || chipColoresTipo["REVERSION"]);

// coordenadas validas: numericas y distintas de (0,0); si no, no se pinta marker
function coordenadasValidas(lat, lon) {
    const vLat = parseFloat(lat);
    const vLon = parseFloat(lon);
    if (isNaN(vLat) || isNaN(vLon)) { return null; }
    if (vLat === 0 && vLon === 0) { return null; }
    return { lat: vLat, lng: vLon };
}

const opcionesEstatus = [
    { value: "PENDIENTE", label: "Pendientes" },
    { value: "AUTORIZADA", label: "Autorizadas" },
    { value: "RECHAZADA", label: "Rechazadas" },
    { value: "TODAS", label: "Todas" },
];

function Autorizar(props) {

    const classes = useStyles();
    const classesAlert = useStylesAlert();

    // filtros del tab Solicitudes
    const [estatus, setEstatus] = React.useState(opcionesEstatus[0]);
    const [fecha, setFecha] = React.useState(null);
    const [guiaFiltro, setGuiaFiltro] = React.useState("");

    // modal de detalle de solicitud (compartido por ambos tabs)
    const [modalOpen, setModalOpen] = React.useState(false);
    const [confirmAccion, setConfirmAccion] = React.useState(null);
    const [comentario, setComentario] = React.useState("");
    const [exito, setExito] = React.useState(null);
    // accion en curso ('autorizar'|'rechazar') mientras el API resuelve; null en reposo.
    // Pinta el overlay de "procesando" del modal, bloquea cerrar/reenviar y sirve para
    // refrescar tras un error (p.ej. el 409 de cierre automatico)
    const [resolviendo, setResolviendo] = React.useState(null);

    // tab Consulta de guia
    const [guiaConsulta, setGuiaConsulta] = React.useState("");
    const [guiaConsultada, setGuiaConsultada] = React.useState("");
    const [entregaDetalle, setEntregaDetalle] = React.useState(null);
    const [entregaModalOpen, setEntregaModalOpen] = React.useState(false);

    const [loading, setLoading] = React.useState(false);

    // gets data when component did mount
    React.useEffect(() => {
        setLoading(true);
        props.getSolicitudesForTable("PENDIENTE", null, null);
    }, []);

    React.useEffect(() => {
        if (props.listData != null) { setLoading(false); }
    }, [props.listData]);

    React.useEffect(() => {
        if (props.guiaData != null) { setLoading(false); }
    }, [props.guiaData]);

    // ante cualquier error apagar el spinner
    React.useEffect(() => {
        if (props.MensajeError != null) { setLoading(false); }
    }, [props.MensajeError]);

    // tras resolver: cerrar modal, refrescar listado (y consulta si aplica) y alerta de exito
    React.useEffect(() => {
        if (props.resolverData != null) {
            setResolviendo(null);
            setModalOpen(false);
            setConfirmAccion(null);
            setExito("La solicitud fue " + props.resolverData.resultado + ".");
            props.limpiarDetalle();
            props.limpiarResolver();
            buscarSolicitudes();
            if (guiaConsultada !== "") {
                props.consultarGuia(guiaConsultada);
            }
        }
    }, [props.resolverData]);

    const buscarSolicitudes = () => {
        setLoading(true);
        const vFecha = fecha ? moment(fecha).format("YYYY-MM-DD") : null;
        const vGuia = guiaFiltro.trim() !== "" ? guiaFiltro.trim() : null;
        props.getSolicitudesForTable(estatus.value, vFecha, vGuia);
    };

    const handleEstatusChange = (selectedOption) => {
        if (selectedOption) {
            setEstatus(selectedOption);
            setLoading(true);
            const vFecha = fecha ? moment(fecha).format("YYYY-MM-DD") : null;
            const vGuia = guiaFiltro.trim() !== "" ? guiaFiltro.trim() : null;
            props.getSolicitudesForTable(selectedOption.value, vFecha, vGuia);
        }
    };

    const handleFechaChange = (date) => {
        setFecha(date);
        setLoading(true);
        const vGuia = guiaFiltro.trim() !== "" ? guiaFiltro.trim() : null;
        props.getSolicitudesForTable(estatus.value, date ? moment(date).format("YYYY-MM-DD") : null, vGuia);
    };

    const limpiarFecha = () => {
        setFecha(null);
        setLoading(true);
        const vGuia = guiaFiltro.trim() !== "" ? guiaFiltro.trim() : null;
        props.getSolicitudesForTable(estatus.value, null, vGuia);
    };

    const validDateTimes = (current) => {
        const today = Datetime.moment();
        return current.isBefore(today);
    };

    const estatusStyles = {
        control: styles => ({ ...styles, marginTop: '27px' }),
        placeholder: styles => ({ ...styles, color: '#AAAAAA' }),
    };

    // ─── Modal de detalle de solicitud ───────────────────────────────────────

    const abrirDetalle = (id) => {
        props.limpiarDetalle();
        setConfirmAccion(null);
        setComentario("");
        setModalOpen(true);
        props.getSolicitudDetalle(id);
    };

    const cerrarModal = () => {
        // con una resolucion en curso el modal no se cierra (ni por ESC/backdrop):
        // el usuario debe ver el resultado o el error de lo que ya envio
        if (resolviendo != null) { return; }
        setModalOpen(false);
        setConfirmAccion(null);
        props.limpiarDetalle();
    };

    const iniciarResolver = (accion) => {
        setComentario("");
        setConfirmAccion(accion);
    };

    const detalle = props.detalleData == null ? null : props.detalleData.resultado;

    const confirmarResolver = () => {
        if (detalle == null || resolviendo != null) { return; }
        setResolviendo(confirmAccion);
        props.resolverSolicitud(detalle.id, confirmAccion, comentario.trim());
        setConfirmAccion(null);
    };

    const renglonDato = (etiqueta, valor) => (
        <p style={{ margin: "3px 0" }}>
            <strong>{etiqueta}:</strong>{" "}{(valor === null || valor === undefined || valor === "") ? "—" : valor}
        </p>
    );

    const galeria = (rutaBase, total, alt) => {
        const imagenes = [];
        const n = parseInt(total, 10) || 0;
        for (let i = 1; i <= n; i++) {
            imagenes.push(<ImagenAuth key={rutaBase + i} src={rutaBase + i} alt={alt + " " + i} />);
        }
        if (imagenes.length === 0) {
            return <p style={{ color: "#9e9e9e", margin: "3px 0" }}>Sin fotos</p>;
        }
        return <div>{imagenes}</div>;
    };

    let puntosComparativo = [];
    if (detalle != null) {
        // DIRECTA no tiene entrega previa: solo el punto de la solicitud (los ant_*
        // llegan vacios y coordenadasValidas ya daria null; el guard lo hace explicito)
        if (detalle.tipo !== "DIRECTA") {
            const puntoAnterior = coordenadasValidas(detalle.ant_lat, detalle.ant_lon);
            if (puntoAnterior != null) {
                puntosComparativo.push({ ...puntoAnterior, titulo: "Entrega original" });
            }
        }
        const puntoNuevo = coordenadasValidas(detalle.lat, detalle.lon);
        if (puntoNuevo != null) {
            puntosComparativo.push({ ...puntoNuevo, titulo: "Devolución solicitada", icono: "mark" });
        }
    }

    let pieDetalle = null;
    if (detalle != null) {
        if (detalle.estatus === "PENDIENTE" && (detalle.puede_autorizar == 1 || detalle.puede_autorizar === true)) {
            pieDetalle = (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                    <Button color="success" onClick={() => iniciarResolver("autorizar")}>Autorizar</Button>
                    {" "}
                    <Button color="danger" onClick={() => iniciarResolver("rechazar")}>Rechazar</Button>
                </div>
            );
        } else if (detalle.estatus === "PENDIENTE") {
            pieDetalle = (
                <p style={{ textAlign: "center", color: "#e65100", fontWeight: 600, marginTop: 10 }}>
                    {detalle.motivo_bloqueo || "La solicitud no puede resolverse por el momento."}
                </p>
            );
        } else {
            pieDetalle = (
                <div style={{ textAlign: "center", marginTop: 10 }}>
                    <p>
                        {chipEstatus(detalle.estatus)}
                        {" "}por <strong>{detalle.nombre_autorizo}</strong> el {detalle.fecha_resolucion}
                    </p>
                    {detalle.comentario_autorizo ? renglonDato("Comentario", detalle.comentario_autorizo) : null}
                </div>
            );
        }
    }

    // overlay "procesando" del modal: hay resolucion en curso y todavia no llego un
    // error (si llego, el SweetAlert de error toma el lugar del overlay)
    const procesando = (resolviendo != null && !props.MensajeError) ? resolviendo : null;

    const modalDetalle = (
        <Dialog
            open={modalOpen} TransitionComponent={Transition} keepMounted onClose={cerrarModal} maxWidth="lg" fullWidth
            // el SweetAlert de confirmacion (con input de comentario) se monta ENCIMA de este
            // Dialog; sin esto el TrapFocus de MUI le roba el foco y el input no se puede teclear
            disableEnforceFocus
        >
            <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid #f3f4f6" }}>
                <span style={{ fontSize: 16, fontWeight: 700 }}>
                    {detalle == null ? "Solicitud de devolución" : "Solicitud de devolución — Guía " + detalle.guia}
                </span>
                {detalle == null ? null : <span style={{ marginLeft: 10 }}>{chipEstatus(detalle.estatus)}</span>}
            </DialogTitle>
            <DialogContent style={{ padding: "16px 20px 20px" }}>
                {detalle == null ? (
                    <div style={{ textAlign: "center", padding: 40 }}>
                        <CircularProgress />
                    </div>
                ) : (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card>
                                <CardBody>
                                    <h4 className={classes.cardIconTitle} style={{ color: "#2e7d32" }}>Entrega original</h4>
                                    {detalle.tipo === "DIRECTA" ? (
                                        // solicitud DIRECTA: no hay snapshot (ant_* vacios), solo el aviso
                                        <p style={{ color: "#9e9e9e", margin: "3px 0" }}>
                                            {"Sin entrega previa — devolución solicitada desde el detalle de la guía (la guía no había sido entregada)."}
                                        </p>
                                    ) : (
                                        <React.Fragment>
                                            {renglonDato("Fecha y hora", detalle.ant_fecha)}
                                            {renglonDato("Recibió", detalle.ant_recibe)}
                                            {renglonDato("Relación", detalle.ant_relacion_recibe)}
                                            {renglonDato("Observaciones", detalle.ant_observaciones)}
                                            {renglonDato("Coordenadas", (coordenadasValidas(detalle.ant_lat, detalle.ant_lon) ? detalle.ant_lat + ", " + detalle.ant_lon : null))}
                                            <p style={{ margin: "8px 0 0" }}><strong>Fotos:</strong></p>
                                            {galeria("autorizar/solicitudes/" + detalle.id + "/foto/anterior/", detalle.fotos_anteriores, "Foto anterior")}
                                            <p style={{ margin: "8px 0 0" }}><strong>Firma:</strong></p>
                                            {(detalle.tiene_firma_anterior == 1)
                                                ? <ImagenAuth src={"autorizar/solicitudes/" + detalle.id + "/firma"} alt="Firma de la entrega original" />
                                                : <p style={{ color: "#9e9e9e", margin: "3px 0" }}>
                                                    Sin firma{detalle.ant_motivo_sin_firma ? " (" + detalle.ant_motivo_sin_firma + ")" : ""}
                                                  </p>}
                                        </React.Fragment>
                                    )}
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            <Card>
                                <CardBody>
                                    <h4 className={classes.cardIconTitle} style={{ color: "#c62828" }}>Devolución solicitada</h4>
                                    {renglonDato("Motivo", detalle.motivo)}
                                    {renglonDato("Observaciones", detalle.observaciones)}
                                    {renglonDato("Chofer", detalle.chofer)}
                                    {renglonDato("Unidad", detalle.unidad)}
                                    {renglonDato("Folio reparto", detalle.folioreparto)}
                                    {renglonDato("Sucursal", detalle.nombresucursal)}
                                    {renglonDato("Fecha solicitud", detalle.fecha_solicitud)}
                                    {renglonDato("Coordenadas", (coordenadasValidas(detalle.lat, detalle.lon) ? detalle.lat + ", " + detalle.lon : null))}
                                    <p style={{ margin: "8px 0 0" }}><strong>Fotos:</strong></p>
                                    {galeria("autorizar/solicitudes/" + detalle.id + "/foto/nueva/", detalle.fotos_nuevas, "Foto nueva")}
                                </CardBody>
                            </Card>
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <MapaComparativo key={"solicitud-" + detalle.id} puntos={puntosComparativo} altura="350px" />
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            {pieDetalle}
                        </GridItem>
                    </GridContainer>
                )}
                <div style={{ width: "100%", textAlign: "center", marginTop: 10 }}>
                    <Button color="warning" onClick={cerrarModal} disabled={procesando != null}>Cerrar</Button>
                </div>
            </DialogContent>
            {procesando == null ? null : (
                // cubre TODO el modal (titulo, contenido y botones) mientras el API resuelve:
                // el Paper del Dialog es position:relative, asi que el absolute lo llena y no
                // se desplaza con el scroll del contenido
                <div
                    role="status"
                    aria-live="polite"
                    style={{
                        position: "absolute", top: 0, left: 0, right: 0, bottom: 0, zIndex: 10,
                        display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center",
                        backgroundColor: "rgba(255,255,255,0.9)", textAlign: "center", padding: 20,
                    }}
                >
                    <CircularProgress size={60} thickness={4} style={{ color: procesando === "autorizar" ? "#2e7d32" : "#c62828" }} />
                    <p style={{ margin: "20px 0 4px", fontSize: 18, fontWeight: 700, color: "#37474f" }}>
                        {procesando === "autorizar" ? "Autorizando la devolución…" : "Rechazando la solicitud…"}
                    </p>
                    <p style={{ margin: 0, fontSize: 14, color: "#607d8b" }}>
                        {detalle == null ? "" : "Guía " + detalle.guia + ". "}
                        Enviando la resolución al servidor, espere un momento. No cierre esta ventana.
                    </p>
                </div>
            )}
        </Dialog>
    );

    // SweetAlert de confirmacion con comentario opcional
    const confirmarAlert = (!confirmAccion || detalle == null) ? null : (
        <SweetAlert
            warning
            showCancel
            style={{ display: "block", marginTop: "-100px" }}
            title={confirmAccion === "autorizar" ? "¿Autorizar la devolución?" : "¿Rechazar la solicitud?"}
            onConfirm={confirmarResolver}
            onCancel={() => setConfirmAccion(null)}
            confirmBtnText={confirmAccion === "autorizar" ? "Autorizar" : "Rechazar"}
            cancelBtnText="Cancelar"
            confirmBtnCssClass={classesAlert.button + " " + (confirmAccion === "autorizar" ? classesAlert.success : classesAlert.danger)}
            cancelBtnCssClass={classesAlert.button}
        >
            {confirmAccion === "autorizar"
                ? "La guía " + detalle.guia + " se marcará como DEVUELTA A ALMACEN."
                : "La solicitud de la guía " + detalle.guia + " quedará RECHAZADA y la entrega original se conserva."}
            <CustomInput
                labelText="Comentario (opcional)"
                formControlProps={{ fullWidth: true }}
                inputProps={{
                    autoComplete: "off",
                    value: comentario,
                    onChange: (event) => setComentario(event.target.value),
                }}
            />
        </SweetAlert>
    );

    const exitoAlert = !exito ? null : (
        <SweetAlert
            success
            style={{ display: "block" }}
            title="Listo!"
            onConfirm={() => setExito(null)}
            onCancel={() => setExito(null)}
            confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
        >
            {exito}
        </SweetAlert>
    );

    const hideAlert = () => {
        props.closeMessages();
        // si el error vino de una resolucion en curso (p.ej. el 409 de cierre automatico),
        // el modal sigue abierto con datos viejos: se recarga el detalle y el listado
        if (resolviendo != null) {
            setResolviendo(null);
            if (detalle != null) {
                const vId = detalle.id;
                props.limpiarDetalle();
                props.getSolicitudDetalle(vId);
            }
            buscarSolicitudes();
        }
    };
    const handleLogOut = () => { props.closeMessages(); props.logout(); };

    let errorMessage = !props.MensajeError ? null : (
        <SweetAlert
            danger
            style={{ display: "block" }}
            title="Error!"
            onConfirm={() => props.MensajeError.indexOf("Acceso denegado") > -1 ? handleLogOut() : hideAlert()}
            onCancel={() => props.MensajeError.indexOf("Acceso denegado") > -1 ? handleLogOut() : hideAlert()}
            confirmBtnCssClass={classesAlert.button + " " + classesAlert.success}
        >
            {props.MensajeError}
        </SweetAlert>
    );

    // ─── Tab Solicitudes ─────────────────────────────────────────────────────

    const listData = props.listData == null ? null : props.listData.data;

    const formattedData = listData == null ? [] : (
        listData.map((prop) => {
            return {
                id: prop.id,
                guia: prop.guia,
                tipo_texto: prop.tipo,
                tipo: chipTipo(prop.tipo),
                nombresucursal: prop.nombresucursal,
                chofer: prop.chofer,
                unidad: prop.unidad,
                folioreparto: prop.folioreparto,
                motivo: prop.motivo,
                fecha_solicitud: prop.fecha_solicitud,
                estatus_texto: prop.estatus,
                estatus: chipEstatus(prop.estatus),
                nombre_autorizo: prop.nombre_autorizo,
                acciones: (
                    // we've added some custom button actions
                    <div className="actions-right">
                        <Button color="success" className={classes.actionButton} onClick={() => {
                            abrirDetalle(prop.id);
                        }}>
                            <VisibilityIcon className={classes.icon} />
                        </Button>{" "}
                    </div>
                )
            }
        })
    );

    const columnasSolicitudes = [
        {
            Header: "Id",
            accessor: "id",
            show: false,
        },
        {
            Header: "Guía",
            accessor: "guia"
        },
        {
            Header: "Tipo",
            accessor: "tipo",
            sortable: false,
            filterable: false
        },
        {
            Header: "Sucursal",
            accessor: "nombresucursal"
        },
        {
            Header: "Chofer",
            accessor: "chofer"
        },
        {
            Header: "Unidad",
            accessor: "unidad"
        },
        {
            Header: "Folio reparto",
            accessor: "folioreparto"
        },
        {
            Header: "Motivo",
            accessor: "motivo"
        },
        {
            Header: "Fecha solicitud",
            accessor: "fecha_solicitud"
        },
        {
            Header: "Estatus",
            accessor: "estatus",
            sortable: false,
            filterable: false
        },
        {
            Header: "Autorizó",
            accessor: "nombre_autorizo"
        },
        {
            Header: "Acciones",
            accessor: "acciones",
            sortable: false,
            filterable: false
        }
    ];

    const tabSolicitudes = (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={3}>
                                <Select
                                    options={opcionesEstatus}
                                    onChange={handleEstatusChange}
                                    styles={estatusStyles}
                                    placeholder="Estatus"
                                    value={estatus}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={2}>
                                <InputLabel className={classes.label}>Fecha solicitud</InputLabel>
                                <br />
                                <FormControl fullWidth>
                                    <Datetime
                                        value={fecha ? moment(fecha).format("DD/MM/YYYY") : ""}
                                        locale="es"
                                        closeOnSelect
                                        timeFormat={false}
                                        inputProps={{
                                            placeholder: "Todas las fechas",
                                            readOnly: true,
                                        }}
                                        onChange={handleFechaChange}
                                        isValidDate={validDateTimes}
                                    />
                                </FormControl>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={1}>
                                <Button
                                    simple
                                    color="danger"
                                    size="sm"
                                    style={{ marginTop: 32 }}
                                    onClick={limpiarFecha}
                                    disabled={fecha == null}
                                >
                                    Limpiar
                                </Button>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                                <CustomInput
                                    labelText="Guía"
                                    formControlProps={{ fullWidth: true }}
                                    inputProps={{
                                        autoComplete: "off",
                                        value: guiaFiltro,
                                        onChange: (event) => setGuiaFiltro(event.target.value),
                                        onKeyPress: (event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                buscarSolicitudes();
                                            }
                                        },
                                    }}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                                <Button
                                    color="success"
                                    onClick={buscarSolicitudes}
                                    className={classes.registerButton}
                                >
                                    <RefreshIcon className={classes.icon} /> Refrescar
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        {listData == null ? (
                            <h4>Cargando informacion...</h4>
                        ) : (
                            <ReactTable
                                data={formattedData}
                                filterable
                                defaultFilterMethod={(filter, row) => {
                                    const id = filter.pivotId || filter.id
                                    return row[id] !== undefined ? String(row[id]).toLowerCase().includes(filter.value.toLowerCase()) : true
                                }
                                }
                                columns={columnasSolicitudes}
                                defaultPageSize={20}
                                showPaginationTop={false}
                                showPaginationBottom
                                className="-striped -highlight"
                                previousText='Anterior'
                                nextText='Siguiente'
                                loadingText='Cargando...'
                                noDataText='No se encontro ningun registro'
                                pageText='Pagina'
                                ofText='de'
                                rowsText='Filas'
                            />
                        )}
                    </CardBody>
                </Card>
            </GridItem>
        </GridContainer>
    );

    // ─── Tab Consulta de guia ────────────────────────────────────────────────

    const buscarGuiaClick = () => {
        const vGuia = guiaConsulta.trim();
        if (vGuia === "") { return; }
        setGuiaConsultada(vGuia);
        setEntregaDetalle(null);
        setEntregaModalOpen(false);
        setLoading(true);
        props.limpiarGuia();
        props.consultarGuia(vGuia);
    };

    const abrirEntrega = (entrega) => {
        setEntregaDetalle(entrega);
        setEntregaModalOpen(true);
    };

    const cerrarEntrega = () => {
        setEntregaModalOpen(false);
    };

    const consulta = props.guiaData == null ? null : props.guiaData.resultado;

    const entregasData = consulta == null || consulta.entregas == null ? [] : (
        consulta.entregas.map((prop) => {
            return {
                id: prop.id,
                fecha: prop.fecha,
                estado: chipEntrega(prop.estado, prop.estado_texto),
                estado_texto: prop.estado_texto,
                recibe: prop.recibe,
                chofer: prop.chofer,
                unidad: prop.unidad,
                folioreparto: prop.folioreparto,
                motivodevolucion: prop.motivodevolucion,
                acciones: (
                    <div className="actions-right">
                        <Button color="success" className={classes.actionButton} onClick={() => {
                            abrirEntrega(prop);
                        }}>
                            <VisibilityIcon className={classes.icon} />
                        </Button>{" "}
                    </div>
                )
            }
        })
    );

    const seguimientoData = consulta == null || consulta.seguimiento == null ? [] : consulta.seguimiento;

    const solicitudesGuiaData = consulta == null || consulta.solicitudes == null ? [] : (
        consulta.solicitudes.map((prop) => {
            return {
                id: prop.id,
                tipo: chipTipo(prop.tipo),
                fecha_solicitud: prop.fecha_solicitud,
                motivo: prop.motivo,
                chofer: prop.chofer,
                folioreparto: prop.folioreparto,
                estatus: chipEstatus(prop.estatus),
                nombre_autorizo: prop.nombre_autorizo,
                acciones: (
                    <div className="actions-right">
                        <Button color="success" className={classes.actionButton} onClick={() => {
                            abrirDetalle(prop.id);
                        }}>
                            <VisibilityIcon className={classes.icon} />
                        </Button>{" "}
                    </div>
                )
            }
        })
    );

    const textosTabla = {
        previousText: 'Anterior',
        nextText: 'Siguiente',
        loadingText: 'Cargando...',
        noDataText: 'No se encontro ningun registro',
        pageText: 'Pagina',
        ofText: 'de',
        rowsText: 'Filas',
    };

    const cardsConsulta = consulta == null ? null : (
        <React.Fragment>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Guía {guiaConsultada}</h4>
                        {consulta.guia == null ? (
                            <p style={{ color: "#9e9e9e" }}>La guía no existe en las tablas maestras.</p>
                        ) : (
                            <GridContainer>
                                <GridItem xs={12} sm={12} md={6}>
                                    {renglonDato("Estado", consulta.guia.estado)}
                                    {renglonDato("Remitente", consulta.guia.remitente)}
                                    {renglonDato("Destinatario", consulta.guia.destinatario)}
                                </GridItem>
                                <GridItem xs={12} sm={12} md={6}>
                                    {renglonDato("Fecha", consulta.guia.fecha)}
                                    {renglonDato("Fecha de entrega", consulta.guia.fechaentrega)}
                                </GridItem>
                            </GridContainer>
                        )}
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Entregas EAD</h4>
                        <ReactTable
                            data={entregasData}
                            filterable={false}
                            columns={[
                                { Header: "Fecha", accessor: "fecha" },
                                { Header: "Estado", accessor: "estado", sortable: false },
                                { Header: "Recibió", accessor: "recibe" },
                                { Header: "Chofer", accessor: "chofer" },
                                { Header: "Unidad", accessor: "unidad" },
                                { Header: "Folio", accessor: "folioreparto" },
                                { Header: "Motivo", accessor: "motivodevolucion" },
                                { Header: "Acciones", accessor: "acciones", sortable: false, filterable: false }
                            ]}
                            defaultPageSize={5}
                            showPaginationTop={false}
                            showPaginationBottom
                            className="-striped -highlight"
                            {...textosTabla}
                        />
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Historial (seguimiento)</h4>
                        <ReactTable
                            data={seguimientoData}
                            filterable={false}
                            columns={[
                                { Header: "Fecha", accessor: "fecha" },
                                { Header: "Hora", accessor: "hora" },
                                { Header: "Estado", accessor: "estado" },
                                { Header: "Ubicación", accessor: "ubicacion" },
                                { Header: "Unidad", accessor: "unidad" },
                                { Header: "Usuario", accessor: "usuario" },
                                { Header: "Bitácora", accessor: "bitacora" }
                            ]}
                            defaultPageSize={10}
                            showPaginationTop={false}
                            showPaginationBottom
                            className="-striped -highlight"
                            {...textosTabla}
                        />
                    </CardBody>
                </Card>
            </GridItem>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <h4 className={classes.cardIconTitle}>Solicitudes de devolución</h4>
                        <ReactTable
                            data={solicitudesGuiaData}
                            filterable={false}
                            columns={[
                                { Header: "Id", accessor: "id", show: false },
                                { Header: "Tipo", accessor: "tipo", sortable: false },
                                { Header: "Fecha solicitud", accessor: "fecha_solicitud" },
                                { Header: "Motivo", accessor: "motivo" },
                                { Header: "Chofer", accessor: "chofer" },
                                { Header: "Folio reparto", accessor: "folioreparto" },
                                { Header: "Estatus", accessor: "estatus", sortable: false },
                                { Header: "Autorizó", accessor: "nombre_autorizo" },
                                { Header: "Acciones", accessor: "acciones", sortable: false, filterable: false }
                            ]}
                            defaultPageSize={5}
                            showPaginationTop={false}
                            showPaginationBottom
                            className="-striped -highlight"
                            {...textosTabla}
                        />
                    </CardBody>
                </Card>
            </GridItem>
        </React.Fragment>
    );

    const tabConsulta = (
        <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
                <Card>
                    <CardBody>
                        <GridContainer>
                            <GridItem xs={12} sm={12} md={4}>
                                <CustomInput
                                    labelText="Guía"
                                    formControlProps={{ fullWidth: true }}
                                    inputProps={{
                                        autoComplete: "off",
                                        value: guiaConsulta,
                                        onChange: (event) => setGuiaConsulta(event.target.value),
                                        onKeyPress: (event) => {
                                            if (event.key === "Enter") {
                                                event.preventDefault();
                                                buscarGuiaClick();
                                            }
                                        },
                                    }}
                                />
                            </GridItem>
                            <GridItem xs={12} sm={12} md={3}>
                                <Button
                                    color="success"
                                    onClick={buscarGuiaClick}
                                    className={classes.registerButton}
                                >
                                    Buscar
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </GridItem>
            {cardsConsulta}
        </GridContainer>
    );

    // sub-detalle de una entrega EAD: galerias de fotos, firma y mini mapa
    const modalEntrega = (
        <Dialog open={entregaModalOpen} TransitionComponent={Transition} keepMounted onClose={cerrarEntrega} maxWidth="md" fullWidth>
            <DialogTitle disableTypography style={{ padding: "16px 20px 12px", borderBottom: "1px solid #f3f4f6" }}>
                <span style={{ fontSize: 16, fontWeight: 700 }}>
                    {entregaDetalle == null ? "Detalle de la entrega" : "Entrega EAD — " + entregaDetalle.fecha}
                </span>
                {entregaDetalle == null ? null : <span style={{ marginLeft: 10 }}>{chipEntrega(entregaDetalle.estado, entregaDetalle.estado_texto)}</span>}
            </DialogTitle>
            <DialogContent style={{ padding: "16px 20px 20px" }}>
                {entregaDetalle == null ? null : (
                    <GridContainer>
                        <GridItem xs={12} sm={12} md={6}>
                            {renglonDato("Recibió", entregaDetalle.recibe)}
                            {renglonDato("Motivo devolución", entregaDetalle.motivodevolucion)}
                            {renglonDato("Observaciones", entregaDetalle.observaciones)}
                            {renglonDato("Chofer", entregaDetalle.chofer)}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={6}>
                            {renglonDato("Unidad", entregaDetalle.unidad)}
                            {renglonDato("Folio reparto", entregaDetalle.folioreparto)}
                            {renglonDato("Sucursal", entregaDetalle.nombresucursal || entregaDetalle.sucursal)}
                            {renglonDato("Coordenadas", (coordenadasValidas(entregaDetalle.lat, entregaDetalle.lon) ? entregaDetalle.lat + ", " + entregaDetalle.lon : null))}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <p style={{ margin: "8px 0 0" }}><strong>Fotos del acto:</strong></p>
                            {galeria("autorizar/entregas/" + entregaDetalle.id + "/foto/acto/", entregaDetalle.num_fotos, "Foto del acto")}
                            <p style={{ margin: "8px 0 0" }}><strong>Fotos diferidas (guía):</strong></p>
                            {galeria("autorizar/entregas/" + entregaDetalle.id + "/foto/guia/", entregaDetalle.num_fotos_guia, "Foto diferida")}
                            <p style={{ margin: "8px 0 0" }}><strong>Firma:</strong></p>
                            {(entregaDetalle.tiene_firma == 1)
                                ? <ImagenAuth src={"autorizar/entregas/" + entregaDetalle.id + "/firma"} alt="Firma de la entrega" />
                                : <p style={{ color: "#9e9e9e", margin: "3px 0" }}>Sin firma</p>}
                        </GridItem>
                        <GridItem xs={12} sm={12} md={12}>
                            <MapaComparativo
                                key={"entrega-" + entregaDetalle.id}
                                puntos={(function () {
                                    const punto = coordenadasValidas(entregaDetalle.lat, entregaDetalle.lon);
                                    return punto == null ? [] : [{ ...punto, titulo: entregaDetalle.estado_texto || "Entrega" }];
                                })()}
                                altura="300px"
                            />
                        </GridItem>
                    </GridContainer>
                )}
                <div style={{ width: "100%", textAlign: "center", marginTop: 10 }}>
                    <Button color="warning" onClick={cerrarEntrega}>Cerrar</Button>
                </div>
            </DialogContent>
        </Dialog>
    );

    const spinner = <Spinner width={"80%"} height={5} color={"black"} loading={loading} />;

    return (
        <React.Fragment>
            {errorMessage}
            {exitoAlert}
            {confirmarAlert}
            <div>{spinner}</div>
            <GridContainer>
                <GridItem xs={12} sm={12} md={12}>
                    <NavPills
                        color="success"
                        tabs={[
                            {
                                tabButton: "Solicitudes",
                                tabContent: tabSolicitudes
                            },
                            {
                                tabButton: "Consulta de guía",
                                tabContent: tabConsulta
                            }
                        ]}
                    />
                </GridItem>
            </GridContainer>
            {modalDetalle}
            {modalEntrega}
        </React.Fragment>
    );
}

const mapStateToProps = (state) => {
    return {
        "listData": state.autorizar.autorizar_List,
        "detalleData": state.autorizar.autorizar_Detalle,
        "resolverData": state.autorizar.autorizar_Resolver,
        "guiaData": state.autorizar.autorizar_Guia,
        "MensajeError": state.autorizar.autorizar_Error_Message,
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        "getSolicitudesForTable": (estatus, fecha, guia) => dispatch(getSolicitudesForTable(estatus, fecha, guia)),
        "getSolicitudDetalle": (id) => dispatch(getSolicitudDetalle(id)),
        "resolverSolicitud": (id, accion, comentario) => dispatch(resolverSolicitud(id, accion, comentario)),
        "consultarGuia": (guia) => dispatch(consultarGuia(guia)),
        "limpiarDetalle": () => dispatch(limpiarDetalle()),
        "limpiarResolver": () => dispatch(limpiarResolver()),
        "limpiarGuia": () => dispatch(limpiarGuia()),
        "closeMessages": () => dispatch(closeMessages()),
        "logout": () => dispatch(logout()),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Autorizar);
